// Third Party Imports
import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import PropTypes from 'prop-types';
import {get} from 'lodash';

// Relative Imports
import appActions from '../../actions/actions';
import payoutDetailsActions from '../../actions/payoutDetails';
import PayoutDetails from './PayoutDetails';

function mapStateToProps(state) {
    return {
        publicUuid: get(state, 'app.publicUuid', '-1'),
        translations: state.app.translations,
        userType: get(state, 'app.userType', 'IPM'),

        enableContinueButton: get(state, 'payoutDetails.enableContinueButton', false),
        enableBackButton: get(state, 'payoutDetails.enableBackButton', false),
        serviceError: get(state, 'payoutDetails.serviceError', ''),

        currency: get(state, 'payoutDetails.userInfo.billingCurrencyCode', ''),

        bankingCountryList: get(state, 'payoutDetails.bankingCountryList', []),
        bankingCountry: get(state, 'payoutDetails.bankingCountry', {}),
        bankingCountryCodeError: get(state, 'payoutDetails.bankingCountryCodeError', ''),
        bankingCountryCode: get(state, 'payoutDetails.bankingCountryCode', ''),

        countryList: get(state, 'payoutDetails.countryList', []),

        showBankingState: get(state, 'payoutDetails.showBankingState', false),
        bankingState: get(state, 'payoutDetails.bankingState', ''),
        bankingStateError: get(state, 'payoutDetails.bankingStateError', ''),

        siteName: get(state, 'system.siteName', ''),
        dyff: get(state,'app.dyff', {}),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        appActions: bindActionCreators(appActions, dispatch),
        payoutDetailsActions: bindActionCreators(payoutDetailsActions, dispatch),
    };
}

class PayoutDetailsContainer extends React.Component {
    constructor(props) {
        super(props);
        this.handleBankingCountryChange = this.handleBankingCountryChange.bind(this);
        this.handleBankingStateChange = this.handleBankingStateChange.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleAlertDismiss = this.handleAlertDismiss.bind(this);
        this.showOnFieldBlur = this.showOnFieldBlur.bind(this);
        this.triggerEdapPageViewAction = this.triggerEdapPageViewAction.bind(this);
    }

    componentDidMount() {
        this.props.appActions.enableLoadOverLay(true);
        this.props.payoutDetailsActions.getPayoutMetadata();
    }

    triggerEdapPageViewAction() {
        this.props.appActions.triggerEdapPageView(this.props.publicUuid, 'Payout Details Page');
    }

    handleFormSubmit(event) {
        event.preventDefault();
        this.props.appActions.enableLoadOverLay(true);
        this.props.appActions.triggerEdapEvent('generic.click', {
            eventcategory: 'Continue',
            eventaction: 'Payout Details Page submit'
        }, {});

        const selectedCountryCode = this.props.bankingCountryCode;
        const selectedBankingCountry = selectedCountryCode && this.props.bankingCountryList.find((country) => country.countryCode === selectedCountryCode);
        const isSupportedCountryAndCurrency = selectedBankingCountry && selectedBankingCountry.currencies.some((c) => c.code === this.props.currency);

        if (isSupportedCountryAndCurrency) {
            this.props.payoutDetailsActions.submitPayoutDetailsForm(this.props.siteName, this.props.bankingCountryCode, this.props.bankingState, this.props.currency);
        } else {
            const countryName =  selectedBankingCountry ? selectedBankingCountry.countryName : this.props.countryList.find((country) => country.countryCode === selectedCountryCode)?.countryName;
            this.props.payoutDetailsActions.setUnsupportedPayoutCountry(countryName);
            this.props.appActions.showIneligibleForm('UNSUPPORTED_PAYOUT_COUNTRY');
        }
    }

    handleBankingCountryChange(event) {
        event.preventDefault();
        this.props.appActions.triggerEdapEvent('generic.event', {
            eventcategory: event.target.name,
            eventaction: 'Banking country selected',
            highfrequency: 'true'
        }, {});
        this.setFieldsError(event.target.id);

        this.props.payoutDetailsActions.handleFieldValueChange(event.target.id, event.target.value);
        this.props.payoutDetailsActions.toggleContinueButton(this.props.currency);
    }

    handleBankingStateChange(event) {
        event.preventDefault();
        this.props.appActions.triggerEdapEvent('generic.event', {
            eventcategory: event.target.name,
            eventaction: 'Banking state selected',
            highfrequency: 'true'
        }, {});
        this.setFieldsError(event.target.id);
        this.props.payoutDetailsActions.handleFieldValueChange(event.target.id, event.target.value);
        this.props.payoutDetailsActions.toggleContinueButton(this.props.currency);
    }

    showOnFieldBlur(event) {
        event.preventDefault();
        if (!event.target.value.trim()) {
            this.setFieldsError(event.target.id);
            this.props.payoutDetailsActions.setFieldError(event.target.id, 'ipmob.input.field.required');
        }
    }

    handleAlertDismiss() {
        this.props.payoutDetailsActions.dismissAlertBox();
    }

    setFieldsError(errorField) {
        const fields = [
            'bankingCountry',
            'bankingState',
        ];

        for (const fieldVal of fields) {
            if (fieldVal === errorField) {
                this.props.payoutDetailsActions.setFieldError(fieldVal, '');
                break;
            }

            if ((fieldVal === 'bankingCountry' && !this.props.bankingCountryCode)
                || (fieldVal === 'bankingState' && !this.props.bankingState)
            ) {
                this.props.payoutDetailsActions.setFieldError(fieldVal, 'ipmob.input.field.required');
            }
        }
    }

    render() {
        return (<div>
            <PayoutDetails
                translations={this.props.translations}
                bankingCountry={this.props.bankingCountry}
                bankingCountryCode={this.props.bankingCountryCode}
                countryList={this.props.countryList}
                handleBankingCountryChange={this.handleBankingCountryChange}
                bankingCountryCodeError={this.props.bankingCountryCodeError}
                handleBankingCountryOnBlur={this.showOnFieldBlur}

                showBankingState={this.props.showBankingState}
                bankingState={this.props.bankingState}
                handleBankingStateChange={this.handleBankingStateChange}
                bankingStateError={this.props.bankingStateError}
                handleBankingStateOnBlur={this.showOnFieldBlur}

                currency={this.props.currency}

                serviceError={this.props.serviceError}
                handleAlertDismiss={this.handleAlertDismiss}
                enableContinueButton={this.props.enableContinueButton}
                enableBackButton={this.props.enableBackButton}
                handleFormSubmit={this.handleFormSubmit}
                triggerEdapPageViewAction={this.triggerEdapPageViewAction}
            />
        </div>);
    }
}

PayoutDetailsContainer.propTypes = {
    translations: PropTypes.any, // eslint-disable-line react/forbid-prop-types
    publicUuid: PropTypes.string,
    bankingCountry: PropTypes.string,
    bankingCountryCode: PropTypes.string,
    bankingState: PropTypes.string,
    showBankingState: PropTypes.bool,
    bankingCountryList: PropTypes.array, // eslint-disable-line react/forbid-prop-types
    countryList: PropTypes.array, // eslint-disable-line react/forbid-prop-types
    enableContinueButton: PropTypes.bool,
    serviceError: PropTypes.string,
    bankingCountryCodeError: PropTypes.string,
    companyName: PropTypes.string,
    currency: PropTypes.string,
    enableBackButton: PropTypes.bool,
    siteName: PropTypes.string,
    userType: PropTypes.string,
};

PayoutDetailsContainer.defaultProps = {
    publicUuid: '-1',
    bankingCountry: '',
    bankingCountryCode: '',
    bankingState: '',
    showBankingState: false,
    bankingCountryList: [],
    countryList: [],
    enableContinueButton: false,
    serviceError: '',
    companyName: '',
    currency: '',
    enableBackButton: false,
    siteName: '',
    userType: 'IPM'
};

export default connect(mapStateToProps, mapDispatchToProps)(PayoutDetailsContainer);
